import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-supply-chain-capacity-utilization-calculator',
  templateUrl: './supply-chain-capacity-utilization-calculator.component.html',
  styleUrls: ['./supply-chain-capacity-utilization-calculator.component.css']
})
export class SupplyChainCapacityUtilizationCalculatorComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    } )

  } 
  caUt(n1,n2){
    var caUti=(n1)/n2;
    var caUtipercent = caUti * 100 ;
    var caUtisimple= caUtipercent.toFixed(2);
    return caUtisimple ;
    }

}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/supply-chain-capacity-utilization-calculator/supply-chain-capacity-utilization-calculator.component.ts